import { Tooltip } from '@noorden-insurtech/alba-design-system';
import { Copy } from 'lucide-react';
import { useCallback } from 'react';
import { toaster } from './toaster.component';

interface CopyableFieldProps {
  value: string;
  label: string;
  truncate?: boolean;
  truncateLength?: number;
}

function truncateValue(value: string, length: number): string {
  if (value.length <= length * 2 + 3) return value;
  return `${value.slice(0, length)}...${value.slice(-length)}`;
}

export function CopyableField({
  value,
  label,
  truncate = false,
  truncateLength = 6,
}: CopyableFieldProps) {
  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(value);
    toaster.create({
      type: 'success',
      title: `${label} copiado para a área de transferência`,
    });
  }, [value, label]);

  const displayValue = truncate ? truncateValue(value, truncateLength) : value;

  return (
    <span className='inline-flex items-center gap-1'>
      <span className='font-medium text-alba-gray-700 text-sm' title={value}>
        {displayValue}
      </span>
      <Tooltip.Root
        openDelay={100}
        closeDelay={0}
        positioning={{ placement: 'top' }}
      >
        <Tooltip.Trigger asChild>
          <button
            type='button'
            onClick={e => {
              e.stopPropagation();
              handleCopy();
            }}
            className='text-alba-gray-400 hover:text-alba-gray-600 transition-colors'
          >
            <Copy size={14} />
          </button>
        </Tooltip.Trigger>
        <Tooltip.Positioner>
          <Tooltip.Content>
            <Tooltip.Arrow />
            Copiar
          </Tooltip.Content>
        </Tooltip.Positioner>
      </Tooltip.Root>
    </span>
  );
}
